(() => {
  const initCollectionNav = (root) => {
    const list = root.querySelector('[data-nazva-collection-nav-list]');
    const prev = root.querySelector('[data-nazva-collection-nav-prev]');
    const next = root.querySelector('[data-nazva-collection-nav-next]');

    if (!list || !prev || !next) return;

    const updateButtons = () => {
      const maxScroll = list.scrollWidth - list.clientWidth;
      prev.disabled = list.scrollLeft <= 1;
      next.disabled = list.scrollLeft >= maxScroll - 1;
      root.classList.toggle('is-scrollable', maxScroll > 1);
      // 2026-09-14: метки краёв для затухания на мобиле (подсказка «есть ещё»)
      root.classList.toggle('is-at-start', list.scrollLeft <= 1);
      root.classList.toggle('is-at-end', list.scrollLeft >= maxScroll - 1);
    };

    const scrollByStep = (direction) => {
      list.scrollBy({
        left: direction * Math.max(list.clientWidth * 0.7, 240),
        behavior: 'smooth',
      });
    };

    prev.addEventListener('click', () => scrollByStep(-1));
    next.addEventListener('click', () => scrollByStep(1));
    list.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    // Drag-scroll мышью на десктопе (как на укр версии): тянем ленту, ссылки не «драгаются»
    const enableDragScroll = (el) => {
      if (!window.matchMedia('(pointer: fine)').matches) return;
      let down = false;
      let moved = false;
      let startX = 0;
      let startScroll = 0;
      let lastX = 0;
      let lastT = 0;
      let velocity = 0;
      let raf = null;

      const stopGlide = () => {
        if (raf) {
          cancelAnimationFrame(raf);
          raf = null;
        }
        el.classList.remove('is-gliding');
      };

      el.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        down = true;
        moved = false;
        startX = e.pageX;
        startScroll = el.scrollLeft;
        lastX = e.pageX;
        lastT = performance.now();
        velocity = 0;
        stopGlide();
        e.preventDefault();
      });

      window.addEventListener('mousemove', (e) => {
        if (!down) return;
        const dx = e.pageX - startX;
        // драг-режим включается ТОЛЬКО после реального движения - обычный клик не задет
        if (!moved && Math.abs(dx) > 4) {
          moved = true;
          el.classList.add('is-dragging');
        }
        if (!moved) return;
        el.scrollLeft = startScroll - dx;
        const now = performance.now();
        const dt = now - lastT;
        if (dt > 0) velocity = (e.pageX - lastX) / dt;
        lastX = e.pageX;
        lastT = now;
      });

      window.addEventListener('mouseup', () => {
        if (!down) return;
        down = false;
        el.classList.remove('is-dragging');
        if (moved) {
          let v = velocity * 16;
          if (Math.abs(v) > 1) {
            el.classList.add('is-gliding');
            const glide = () => {
              el.scrollLeft -= v;
              v *= 0.92;
              if (Math.abs(v) > 0.4) {
                raf = requestAnimationFrame(glide);
              } else {
                stopGlide();
              }
            };
            raf = requestAnimationFrame(glide);
          }
          // click после драга гасится обработчиком ниже; сброс флага - после него
          setTimeout(() => {
            moved = false;
          }, 0);
        }
      });

      el.addEventListener(
        'click',
        (e) => {
          if (moved) {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        true
      );

      el.addEventListener('dragstart', (e) => e.preventDefault());
    };
    enableDragScroll(list);

    const activeLink = list.querySelector('.is-active');
    if (activeLink) {
      activeLink.scrollIntoView({ inline: 'center', block: 'nearest' });
    }

    updateButtons();
  };

  document.querySelectorAll('[data-nazva-collection-nav]').forEach(initCollectionNav);
})();
